/**
 * Chi può fare cosa, con gli stessi confini che ha il server.
 *
 * I permessi veri stanno nel backend (`require_gestione`, `require_tecnico`,
 * `require_admin`): qui si decide solo se il pulsante si vede. Le due cose
 * devono combaciare, altrimenti succede una delle due cose sbagliate - un
 * pulsante che risponde «permessi insufficienti», oppure, come è capitato,
 * una pagina che c'è ma a chi ci lavora non compare.
 *
 * L'amministrativo è il caso da tenere d'occhio: il server lo tratta come un
 * amministratore su dipendenti, mezzi, articoli e documenti, e gli dà tutto
 * quello che dà al tecnico. Se una schermata si mostra al tecnico e non a lui,
 * è un errore, non una scelta.
 */

// Chi crea, modifica e archivia: `require_gestione` sul server.
export const GESTIONE = ["admin", "amministrativo"];

// Chi lavora sui contenuti, compresi i tecnici: `require_tecnico` sul server.
export const OPERATIVI = ["admin", "amministrativo", "tecnico"];

export const puoGestire = (user) => GESTIONE.includes(user?.role);
export const puoOperare = (user) => OPERATIVI.includes(user?.role);

// Resta all'amministratore quello che si fa una volta e non si disfa: utenti,
// cancellazioni definitive, pulizie di massa, registro, impostazioni.
export const eAmministratore = (user) => user?.role === "admin";
